import { t } from '@/i18n';
import { DateRangeSchema, sortOrderType } from '@/utils';
import { z } from 'zod';
import { NAME_MAX_LENGTH } from '../utils';

export const accountingType = z.enum(['general', 'special']);

export const AccountingTypeModel = z.object({
  id: z.string().uuid(),
  code: z.number().int().min(1),
  type: z.string().nullish(),
  name: z.string().min(1),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const AccountingTypesModel = AccountingTypeModel.array();

export const AccountingTypeFormSchema = AccountingTypeModel.pick({
  type: true,
  code: true,
}).extend({
  name: AccountingTypeModel.shape.name.max(NAME_MAX_LENGTH),
  period: DateRangeSchema.nullish(),
});

export const AccountingTypeLabelModifier = {
  general: t('general-account'),
  special: t('special-account'),
} as const satisfies Record<z.infer<typeof accountingType>, string>;

export const UpdateAccountingTypeSortOrderParamsSchema =
  AccountingTypeModel.pick({
    id: true,
  })
    .extend({
      sortOrder: sortOrderType,
    })
    .array();
